var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataLoaded)?_c('edit-form',{attrs:{"delete-btn":"","model":_vm.$store.getters['model' + _vm.modelName],"rawValues":_vm.$store.getters['one' + _vm.modelName]},on:{"submit":_vm.save,"delete":_vm.del}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }